import { z } from 'zod';
export const AssetSchema = z.object({
    assetId: z.string().describe('Unique identifier for the asset'),
    mimeType: z.string().describe('MIME type of the asset, e.g., image/png'),
    metadata: z.object({
        fileName: z.string().describe('Original filename of the asset'),
        size: z.number().describe('Size of the asset in bytes'),
        providerId: z
            .string()
            .describe('Provider-specific identifier for the asset, if any')
            .optional(),
    }),
});
